export const ensureHTTPS = () => {
    if (!window.location.href.includes("https") && !window.location.href.includes("localhost")) {
        const newURL = window.location.href.replace("http", "https");
        window.location.replace(newURL);
    }
};